export default class ProductGroups {
  constructor($scope, ProductService, PaginationService) {
    $scope.quick_search = function () {
      window.filter_table('table#groups', $scope.query);
    };

    $scope.get_groups = function () {
      $scope.searching = true;
      ProductService.get_group_data($scope.filter).then(function (data) {
        $scope.groups = data.groups;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.searching = false;
      });
    };

    $scope.get_page_data = function (page) {
      $scope.filter.page = page;
      $scope.get_groups();
    };

    $scope.init_filter = function () {
      $scope.filter = {
        page: 1,
        per_page: 50,
        category_id: null,
        has_products: 'All',
        properties: 'All',
        is_website_visible: false,
        has_description: 'All',
        has_meta_tags: 'All',
        has_usp_vp: 'All'
      };
    };

    $scope.categories = window.categories;
    $scope.init_filter();
    $scope.get_groups();
  }
}

ProductGroups.$inject = ['$scope', 'ProductService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-groups.ctrl.js